import { extractPlainTextFromBlocksContent } from '@/lib/blocks-content';

export const getCaseStudyBreadcrumbTitle = (page: {
	content?: Array<{ __component?: string; title?: unknown }>;
	seo?: { title?: string };
}): string => {
	const heroBlock = page.content?.find(block => block.__component === 'case.hero');

	if (heroBlock?.title) {
		const title = extractPlainTextFromBlocksContent(heroBlock.title as never);
		if (title) return title;
	}

	return page.seo?.title ?? 'Case Study';
};
